export { default as LifestylesIndexPageCategoriesNav } from './LifestylesIndexPageCategoriesNav';
